import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { connect } from "react-redux";
import moment from 'moment';

import { fetchRegisterID, fetchRegisterFee, setRegisterEdit, setModifiedRegister, fetchRegistertickets, transactionStatus, setOpenTicketStatus } from '../../../redux/actions/RegisterActions';
import { fetchRegisterTransactions } from '../../../redux/actions/TransactionActions';
import { registerHeading, registerFeeHeading, tableHeadings } from '../../../utils/constants';
import { setMerchantID } from '../../../redux/actions/MerchantActions'
import { fetchMerchants } from '../../../redux/actions/DropdownActions';

import { Panel, PanelBody, PanelHeader } from "../../header/panel/panel"

import SweetAlert from 'react-bootstrap-sweetalert';

import TableView from '../Table/Table';
import RegisterTransactionTest from './RegisterTransactionTest';
import RegisterFeeEdit from './RegisterFeeEdit';
import { Dialog, DialogContent } from '@mui/material';
import TransactionStatusPage from './TransactionStatusPage';



const RegisterProfile = (props) => {

    const navigate = useNavigate()

    const heading = registerHeading;

    const feeHeading = registerFeeHeading;

    const FEE_TYPE_LABELS = {
        '1': 'Cash Back Only',
        '2': 'Total Amount',
        '3': 'Fee Plus',
        '4': 'Tiered',
    }

    const [addModelOpen, setAddModelOpen] = useState(false)
    const [showTransactionModelOpen, setShowTransactionModelOpen] = useState(false)
    const [showTransactionStatusModel, setShowTransactionStatusModel] = useState(false)
    const [showFeeEditModelOpen, setShowFeeEditModelOpen] = useState(false)

    const [ticketdata, setTicketData] = useState(null)

    const registerDetails = props.REGISTERREDUCER.registerData && props.REGISTERREDUCER.registerData.length ? props.REGISTERREDUCER.registerData[0] : null
    const isCashForDebit = registerDetails ? (registerDetails.cashForDebit === true || registerDetails.cashForDebit === 'true' || registerDetails.cashForDebit === 1) : false

    useEffect(() => {
        let registerID = props.REGISTERREDUCER.registerID;
        console.log('Register ID ', registerID)
        if (registerID) {
            props.fetchRegisterID(registerID)
            props.fetchRegisterFee(registerID)
            props.fetchRegisterTransactions(registerID)
            props.fetchRegistertickets(registerID)

        }
        props.setModifiedRegister(false)
        return () => {
            props.setRegisterEdit(false)
        }
    }, [])

    const handleMerchantClick = () => {
        props.setMerchantID(props.REGISTERREDUCER.registerData[0].merchantID)
        navigate('/merchant/view')
    }

    const handleEditRegister = () => {
        props.fetchMerchants(props.REGISTERREDUCER.registerData[0].merchantID)
        navigate('/register/edit')
    }

    const onCellClicked = (value) => {
        {console.log('Ticket Data 1 : ', value.data)}
        setTicketData(value.data)
    }

    const onTransactionStatusClick = () => {
         setShowTransactionStatusModel(true)
    }

    

    const TOKEN_FORM = (


        <p className="lead text-dark ">

            <SweetAlert showCancel
                onConfirm={() => setAddModelOpen(!addModelOpen)}
                cancelBtnBsStyle="default"
                onCancel={() => setAddModelOpen(!addModelOpen)}
            >

                <Panel >
                    <PanelHeader>Token</PanelHeader>
                    <PanelBody>
                        <p className="lead text-dark">{props.REGISTERREDUCER?.registerData[0]?.registerAccessToken}</p>
                    </PanelBody>
                </Panel>
            </SweetAlert>
        </p>
    )

    const TRANSACTION_FORM = (

        <div>
            <Dialog
                open={showTransactionModelOpen}
                onClose={() => setShowTransactionModelOpen(!showTransactionModelOpen)}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                maxWidth={false}
                PaperProps={{ sx: { width: '50vw', maxWidth: '50vw', height: '80vh', maxHeight: '80vh' } }}
            >
                <DialogContent>
                    <RegisterTransactionTest setShowTransactionModelOpen = {setShowTransactionModelOpen}></RegisterTransactionTest>
                </DialogContent>
            </Dialog>
        </div>

    )

    const FEE_EDIT_FORM = (

        <div>
            <Dialog
                open={showFeeEditModelOpen}
                onClose={() => setShowFeeEditModelOpen(!showFeeEditModelOpen)}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogContent>
                    <RegisterFeeEdit setShowFeeEditModelOpen={setShowFeeEditModelOpen}></RegisterFeeEdit>
                </DialogContent>
            </Dialog>
        </div>

    )



    
    const TRANSACTION_STATUS = (

        <div>
            <Dialog
                open={showTransactionStatusModel}
                onClose={() => setShowTransactionStatusModel(!showTransactionStatusModel)}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogContent>
                    {console.log('Ticket Data : ' + ticketdata?.transactionID)}
                    <TransactionStatusPage transactionID = {ticketdata?.transactionID}></TransactionStatusPage>
                </DialogContent>
                {/* <DialogActions>
                <button className="btn btn-secondary d-block w-30 btn-xs h-9px fs-11px" onClick={handleGetTransactionStatus}>Get Transaction Response</button>
                </DialogActions> */}
            </Dialog>
        </div>

    )


    const ButtonRenderer = (params) => {
        const handleClick = () => {
          // Get another cell's value (Example: name column value)
          setTicketData(params?.data);
          onTransactionStatusClick();
        };
    
        return <button className="btn btn-secondary d-block w-30 btn-xs h-9px fs-11px" onClick={handleClick}>Get Transaction Status</button>;
      };
    


    const headings = {

        registerTickets: [
            
            {
                field: 'createdDate',  headerName: 'Ticket Time', minWidth: 200, cellRenderer: function (params) {
                    return moment(params.value).format('MMM DD, YYYY HH:mm:ss');
                }
            },
            { field: 'transactionID', headerName: 'Transaction ID', minWidth: 180},
            { field: 'tranType', headerName: 'Transaction Type', maxWidth: 200 },
            {
                field: 'amount', headerName: 'Amount', minWidth: 80, maxWidth: 120, cellRenderer: function (params) {
                    return "$" + params.data.amount
                },
            },
            {
                field: 'ticketStatus', tooltipField: 'ticketStatus', headerName: 'Ticket Status', minWidth: 120, cellRenderer: function (params) {
                    return  params.data.ticketStatus
                },
            },
            {
                field: 'Action', tooltipField: 'action', headerName: '', minWidth: 250, cellRenderer: ButtonRenderer
            },
        ],
    }


        return (
            
        <div className="row mb-3">

            <div className="col-xl-4">

                <Panel>

                    <PanelHeader>

                        <div className="row mb-0">

                            <div className="col-xl-10">
                                <b>
                                    REGISTER PROFILE
                                </b>
                            </div>

                            <div className="col-xl-2">

                                {/* eslint-fix: preserve loose-equality coercion */}
                                {Number(props.LOGINREDUCER.USER.role) === 1 || Number(props.LOGINREDUCER.USER.role) === 6 ? <button className='btn btn-secondary d-block w-30 btn-xs h-9px fs-11px' onClick={handleEditRegister}>Edit</button> : null}

                            </div>

                        </div>


                    </PanelHeader>

                    <PanelBody>

                        <div className="table-responsive">

                            <table className="table mb-0">
                                <tbody>

                                    {props.REGISTERREDUCER.registerData && props.REGISTERREDUCER.registerData.length ? Object.keys(heading).map(data => {

                                        switch (data) {
                                            case 'lastUpdated':
                                            case 'createDate':
                                                return (
                                                    <tr key={data}>
                                                        <th style={{ width: '40%' }} >{heading[data]}</th>
                                                        <th>:</th>
                                                        <td>{props.REGISTERREDUCER.registerData[0] && Object.keys(props.REGISTERREDUCER.registerData[0]).includes(data) ? moment(props.REGISTERREDUCER.registerData[0][data]).format('MMM DD, YYYY hh:mm:ss A') : '-'}</td>
                                                    </tr>
                                                )

                                            case 'registerStatusID':
                                                return (

                                                    <tr key={data}>
                                                        <th style={{ width: '40%' }}>{heading[data]}</th>
                                                        <th>:</th>

                                                        {/* eslint-fix: preserve loose-equality coercion */}
                                                        <td className={Number(props.REGISTERREDUCER.registerData[0][data]) === 1 ? 'approved' : Number(props.REGISTERREDUCER.registerData[0][data]) === 2 ? 'suspended' : Number(props.REGISTERREDUCER.registerData[0][data]) === 3 ? 'inactive' : 'reject'}>{props.REGISTERREDUCER.registerData[0] && Object.keys(props.REGISTERREDUCER.registerData[0]).includes(data) ? Number(props.REGISTERREDUCER.registerData[0][data]) === 1 ? 'Active' : Number(props.REGISTERREDUCER.registerData[0][data]) === 2 ? 'Suspended' : Number(props.REGISTERREDUCER.registerData[0][data]) === 3 ? 'InActive' : 'Deleted' : '-'}</td>
                                                    </tr>
                                                )
                                            case 'merchantName':
                                                return (
                                                    <tr key={data}>
                                                        <th style={{ width: '40%' }}>{heading[data]}</th>
                                                        <th>:</th>
                                                        <td>
                                                            {/* eslint-fix: preserve loose-equality coercion */}
                                                            {Number(props.LOGINREDUCER.USER.role) === 1 || Number(props.LOGINREDUCER.USER.role) === 6 ? <button size='small' onClick={handleMerchantClick}><b>{props.REGISTERREDUCER.registerData[0] && Object.keys(props.REGISTERREDUCER.registerData[0]).includes(data) && (props.REGISTERREDUCER.registerData[0][data] !== null && props.REGISTERREDUCER.registerData[0][data] !== undefined) ? props.REGISTERREDUCER.registerData[0][data] : '-'} </b></button> : props.REGISTERREDUCER.registerData[0][data]}
                                                        </td>
                                                    </tr>
                                                )
                                            case 'registerAccessToken':
                                                return (
                                                    <tr key={data}>
                                                        <th style={{ width: '40%' }}>{heading[data]}</th>
                                                        <th>:</th>
                                                        <td>
                                                            <button size='small' onClick={() => setAddModelOpen(true)}><b>Get Token</b></button></td>
                                                        {/* <TableCell>{props.REGISTERREDUCER.registerData[0] && Object.keys(props.REGISTERREDUCER.registerData[0]).includes(data) && props.REGISTERREDUCER.registerData[0][data] != null ? props.REGISTERREDUCER.registerData[0][data] : '-'}</TableCell> */}
                                                    </tr>
                                                )
                                            default:
                                                return (
                                                    <tr key={data}>
                                                        <th style={{ width: '40%' }}>{heading[data]}</th>
                                                        <th>:</th>
                                                        <td>{props.REGISTERREDUCER.registerData[0] && Object.keys(props.REGISTERREDUCER.registerData[0]).includes(data) && props.REGISTERREDUCER.registerData[0][data] != null ? props.REGISTERREDUCER.registerData[0][data] : '-'}</td>
                                                    </tr>

                                                )
                                        }
                                    }) : null}

                                </tbody>
                            </table>
                        </div>

                    </PanelBody>
                </Panel>

                {isCashForDebit ?
                <Panel>

                    <PanelHeader>
                        <div className="row mb-0">
                            <div className="col-xl-10">
                                <b>
                                    REGISTER FEE
                                </b>
                            </div>
                            <div className="col-xl-2">
                                {/* eslint-fix: preserve loose-equality coercion */}
                                {Number(props.LOGINREDUCER.USER.role) === 1 || Number(props.LOGINREDUCER.USER.role) === 6 ? <button className='btn btn-secondary d-block w-30 btn-xs h-9px fs-11px' onClick={() => setShowFeeEditModelOpen(true)}>Edit</button> : null}
                            </div>
                        </div>
                    </PanelHeader>

                    <PanelBody>

                        <div className="table-responsive">

                            <table className="table mb-0">
                                <tbody>

                                    {props.REGISTERREDUCER.registerFee && props.REGISTERREDUCER.registerFee.length ? Object.keys(feeHeading).map(data => {
                                        const fee = props.REGISTERREDUCER.registerFee[0]
                                        const hasValue = fee && Object.keys(fee).includes(data) && fee[data] !== null && fee[data] !== undefined
                                        let displayValue = hasValue ? fee[data] : '-'
                                        if (data === 'overrideType' && hasValue) {
                                            displayValue = FEE_TYPE_LABELS[String(fee[data])] || fee[data]
                                        } else if ((data === 'overrideData' || data === 'overrideThreshold') && hasValue) {
                                            displayValue = '$' + fee[data]
                                        }
                                        return (
                                            <tr key={data}>
                                                <th style={{ width: '40%' }}>{feeHeading[data]}</th>
                                                <th>:</th>
                                                <td>{displayValue}</td>
                                            </tr>
                                        )
                                    }) : null}

                                </tbody>
                            </table>
                        </div>

                    </PanelBody>
                </Panel>
                : null}


            </div>

            <div className="col-xl-8">

                <Panel>
                    <PanelHeader>
                        <div className="row mb-0">
                            <div className="col-xl-10">
                                <b>TRANSACTIONS</b>
                            </div>

                        </div>

                    </PanelHeader>
                    <TableView height={600} count={13} headings={tableHeadings.registerTransactions} data={props.TRANSACTIONREDUCER.registerTransactionData} />
                </Panel>

            </div>
            <div className="col-xl-12">
                <Panel>
                    <PanelHeader>
                        <div className="row mb-0">

                            <div className="col-xl-10">
                                <b>TICKETS</b>
                            </div>
                            <div className="col-xl-2">
                                <button className="btn btn-secondary d-block w-30 btn-xs h-9px fs-11px" onClick={() => setShowTransactionModelOpen(true)}>Test Register</button>
                            </div>
                        </div>

                    </PanelHeader>

                    <TableView height={600} count={13} headings={headings.registerTickets} data={(props.REGISTERREDUCER.registerTickets ? props.REGISTERREDUCER.registerTickets : null)}  handleClick = {onCellClicked}/>
                </Panel>

            </div>
            {addModelOpen ? TOKEN_FORM : null}
            {/* {showTransactionModelOpen ? TRANSACTION_FORM : null} */}
            {TRANSACTION_FORM}
            {TRANSACTION_STATUS}
            {FEE_EDIT_FORM}

        </div>


    )
}

function mapStateToProps(state) {
    return state
}

const mapDispatchToProps = {
    fetchRegisterID,
    fetchRegisterFee,
    setRegisterEdit,
    setModifiedRegister,
    setMerchantID,
    fetchRegistertickets,
    fetchRegisterTransactions,
    fetchMerchants,
    transactionStatus,
    setOpenTicketStatus
}


export default connect(mapStateToProps, mapDispatchToProps)(RegisterProfile);